var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-nav-bar',{attrs:{"title":_vm.modelFileName,"fixed":"","left-arrow":_vm.hasLeft},on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([{key:"right",fn:function(){return [_c('span',{staticClass:"jylabel",on:{"click":_vm.closeDwg}},[_vm._v("3D")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }